export enum PaddingSize {
	None = 'none',
	Default = 'default',
	Medium = 'medium',
	Large = 'large',
}
